import {analyticsKpiSlice} from './analyticsKpiSlice';

export default analyticsKpiSlice.reducer;
